import { Node_Type, type Node } from '@wix/ricos';
import {
  type NodeViewDecorator,
  type ViewerPluginCreator,
} from '@wix/ricos/dist/src/ricos-types';
import React from 'react';

export const htmlAttributesPlugin: ViewerPluginCreator<{}> = (_) => ({
  config: {},
  type: '',
  nodeViewDecorators: [htmlAttributesDecorator],
  nodeViewRenderers: {
    [Node_Type.EXTERNAL]: (__) => <></>,
  },
});

const htmlAttributesDecorator: NodeViewDecorator<React.JSX.Element> = {
  rule: (node: Node) => node.type === Node_Type.EXTERNAL,
  decorate: ({ node }) => {
    if (node.textData?.text == null) {
      return <></>;
    }
    const props = Object.fromEntries(
      Object.entries(node.externalData?.fields ?? []).map(([k, v]) => [
        k,
        v.stringValue,
      ]),
    );
    return <span {...props}>{node.textData?.text}</span>;
  },
};
